export const Subscriptions =
{
    POS: 'POS',
    Inventory: 'Inventory',
    Marketing: 'Marketing',
    Payroll: 'Payroll',
    Accounts: 'Accounts',
    DocumentExplorer: 'Document Explorer',
    FoodSafety: 'Food Safety',
    Signage: 'Signage',
    BrandedApp: 'Branded APP',
    CentralKitchen: 'Central Kitchen'
}